<div class="vflex-300">
  <h2>Tables</h2>
  <div class="surface-muted border-radius-200 pad-200">
    <code>import &#123; TableComponent &#125; from '&#64;spaces-ui/meadow/components/table';</code>
  </div>

  <h3>Table Config:</h3>
  <mdw-table
    class="docs-table"
    scrollStyle="immediate"
    [tableConfig]="tableConfigDocs"
    rowHeight="unset"
    [rowPadding]="16"
  ></mdw-table>

  <h3>Column Config:</h3>
  <mdw-table
    class="docs-table"
    scrollStyle="immediate"
    [tableConfig]="columnConfigDocs"
    rowHeight="unset"
    [rowPadding]="16"
  ></mdw-table>

  <h3>Actions Config:</h3>
  <mdw-table
    class="docs-table"
    scrollStyle="immediate"
    [tableConfig]="actionConfigDocs"
    rowHeight="unset"
    [rowPadding]="16"
  ></mdw-table>

  <h3>Selection Action Config:</h3>
  <mdw-table
    class="docs-table"
    scrollStyle="immediate"
    [tableConfig]="selectionActionConfigDocs"
    rowHeight="unset"
    [rowPadding]="16"
  ></mdw-table>

  <h3>Zero State Config:</h3>
  <mdw-table
    class="docs-table"
    scrollStyle="immediate"
    [tableConfig]="zeroStateConfigDocs"
    rowHeight="unset"
    [rowPadding]="16"
  ></mdw-table>

  <h3>Table Zero State</h3>
  <p>This uses a table without any items</p>
  <ng-template #noItemsTable data-sample="noItemsTable">
    <mdw-table scrollStyle="immediate" [tableConfig]="noItemsTableConfig"></mdw-table>
  </ng-template>
  <app-sample [sampleContent]="noItemsTable" sampleName="noItemsTable"></app-sample>

  <hr />

  <h3>Table Zero State</h3>
  <p>This uses a table without any items</p>
  <ng-template #noSearchItemsTable data-sample="noSearchItemsTable">
    <mdw-table scrollStyle="immediate" [tableConfig]="noSearchItemsTableConfig"></mdw-table>
  </ng-template>
  <app-sample [sampleContent]="noSearchItemsTable" sampleName="noSearchItemsTable"></app-sample>

  <hr />

  <h3>Simple Table</h3>
  <p>This uses a table without virtual scrolling</p>
  <ng-template #simpleTable data-sample="simpleTable">
    <mdw-table scrollStyle="immediate" [tableConfig]="simpleTableConfig"></mdw-table>
  </ng-template>
  <app-sample [sampleContent]="simpleTable" sampleName="simpleTable"></app-sample>

  <hr />

  <h3>Virtual Scroll Table</h3>
  <p>This uses a table with virtual scrolling</p>
  <ng-template #virtualTable data-sample="virtualTable">
    <mdw-table scrollStyle="virtual" [tableConfig]="virtualTableConfig"></mdw-table>
  </ng-template>
  <app-sample [sampleContent]="virtualTable" sampleName="virtualTable"></app-sample>

  <hr />

  <h3>Sortable Table</h3>
  <p>This uses a table with virtual scrolling and sorting</p>
  <ng-template #sortTable data-sample="sortTable">
    <mdw-table
      scrollStyle="virtual"
      [tableConfig]="sortableTableConfig"
      (sort)="handleSort($event)"
    ></mdw-table>
  </ng-template>
  <app-sample [sampleContent]="sortTable" sampleName="sortTable"></app-sample>

  <h3>Table with actions</h3>
  <p>This uses a table that has actions for every item</p>
  <ng-template #actionsTable data-sample="actionsTable">
    <mdw-table
      scrollStyle="virtual"
      [tableConfig]="actionsTableConfig"
      (handleAction)="handleAction($event)"
    ></mdw-table>
  </ng-template>
  <app-sample [sampleContent]="actionsTable" sampleName="actionsTable"></app-sample>

  <h3>Table with selection actions</h3>
  <p>
    Enable <code>selectable</code> to prepend a checkbox column. Selecting rows reveals a toolbar
    (in place of the column headers) with the configured <code>selectionActions</code>. The "Merge"
    action only appears once 2 or more rows are selected.
  </p>
  <ng-template #selectionTable data-sample="selectionTable">
    <mdw-table
      scrollStyle="virtual"
      [tableConfig]="selectionTableConfig"
      (selectionChange)="onSelectionChange($event)"
      (handleSelectionAction)="onSelectionAction($event)"
    ></mdw-table>
  </ng-template>
  <app-sample [sampleContent]="selectionTable" sampleName="selectionTable"></app-sample>

  <h3>Custom cell renderer</h3>
  <p>This uses a table that overwrites the rendering of a particular column's cells</p>
  <ng-template #customRenderer data-sample="customRenderer">
    <mdw-table
      scrollStyle="virtual"
      [tableConfig]="customRendererTableConfig()"
      (handleAction)="handleAction($event)"
    ></mdw-table>
    <ng-template #userRenderer let-member>
      <div class="hflex-200 flex-align-items-center fill-flex overflow-hidden fill-width">
        <mdw-avatar
          [src]="undefined"
          [srcVersion]="0"
          [name]="member.name"
          [color]="member.avatarColor"
          [loadingUser]="false"
        ></mdw-avatar>
        <div class="dense overflow-text-ellipses">
          {{ member.name }}
        </div>
      </div>
    </ng-template>
  </ng-template>
  <app-sample [sampleContent]="customRenderer" sampleName="customRenderer"></app-sample>
</div>
